import { Moment } from 'moment';
import {EnderecoEntidade} from './endereco-entidade.model';
import { PessoaJuridicaView } from './pessoa-juridica-view.model';
import { TipoEntidade } from './tipo-entidade.model';
import { TipoSituacaoEntidade } from './tipo-situacao-entidade.model';
import {TipoSituacaoGeral} from './tipo-situacao-geral.model';
import {TipoSituacaoSiplani} from './tipo-situacao-sigplani.model';
import {SituacaoEntidade} from "./situacao-entidade.model";
import {SituacaoGeral} from "./situacao-geral.model";

export class Entidade {

  id: number;
  idEntidadePai: number;
  idMomentoPessoaJuridica: number;
  idUnicoPessoaJuridica: number;
  tipoSituacaoEntidade: TipoSituacaoEntidade;
  tipoEntidade: TipoEntidade;
  dataCadastro: Moment;
  dataUltimaAtualizacaoSituacao: Moment;
  nomeUnidade: string;
  numeroRegistroCVM: number;
  tipoCapital: number;
  possuiUnidadeVinculada: boolean;
  pessoaJuridicaView: PessoaJuridicaView;
  tipoSituacaoSigplani: TipoSituacaoSiplani;
  tipoSituacaoGeral: TipoSituacaoGeral;
  situacaoGeral: SituacaoGeral;
  situacao: SituacaoEntidade[];
  aptaHabitar: boolean;
  gerarCreditoGeral: boolean;
  gerarCreditoParcial: boolean;

  constructor(init?: Partial<EnderecoEntidade>) {
    Object.assign(this, init);
  }
}
